import { OFFLINE_CREATE_FILE_DB_INFO } from '@/modules/OfflineFiles/data/OfflineFilesDatabaseInfo';
import { userInfoQueryOptions } from '@/common/queries/userInfo/userInfoQueryOptions';
import { OfflinePhotosDBTypes } from '@/modules/OfflineFiles/types/OfflineFileTypes';
import { getOfflineCheckListQueryOptions } from '@/modules/OfflineFiles/queries/getOfflineCheckList/getOfflineCheckListQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import useIndexDb from '@/modules/OfflineFiles/hooks/useIndexDb';

const useOfflineFilesCheckList = () => {
  const { getAllFromIndexDb, deleteItemFromIndexDb } =
    useIndexDb<OfflinePhotosDBTypes>(OFFLINE_CREATE_FILE_DB_INFO);
  const { data: userInfo, isSuccess: userInfoIsSuccess } = useQuery(
    userInfoQueryOptions(),
  );

  const { data: offlineData, isSuccess } = useQuery(
    getOfflineCheckListQueryOptions(),
  );
  const checkOfflineFiles = () => {
    getAllFromIndexDb().then((item) => {
      const currentAdjusterFiles = item.filter(
        (dbItem) => dbItem.adjusterId === userInfo?.id,
      );
      const ValidOfflineFilesMap = new Map(
        offlineData?.results.map((item) => [
          `${item.id}_${item.user_type}${item.user_type === 'damaged' ? `_${item.damaged_id}` : ''}`,
          item,
        ]),
      );

      currentAdjusterFiles.forEach((dbItem) => {
        const userType =
          dbItem.userType === 'initial' || dbItem.userType === 'body'
            ? 'insurer'
            : dbItem.userType;

        const key = `${dbItem.fileId}_${userType}${dbItem.userType === 'damaged' ? `_${dbItem.damagedId}` : ''}`;

        if (!ValidOfflineFilesMap.has(key) && dbItem.id) {
          deleteItemFromIndexDb(dbItem.id);
        }
      });
    });
  };

  useEffect(() => {
    if (userInfoIsSuccess && isSuccess) checkOfflineFiles();
  }, [userInfoIsSuccess, isSuccess]);
  return { checkOfflineFiles };
};

export default useOfflineFilesCheckList;
